/**
 * Carpinteria Commercial Painting Schema
 * Enhanced LocalBusiness schema for commercial painting in Carpinteria
 */

export function getCarpinteriaCommercialSchema() {
  return {
    "@context": "https://schema.org",
    "@type": "HousePainter",
    "name": "Danis Painting Co. - Carpinteria Commercial Painting",
    "description": "Premier commercial painting contractor serving Carpinteria businesses: Linden Avenue, Carpinteria Plaza, beach hotels, coastal restaurants. Salt-resistant, marine-grade coatings for coastal climate.",
    "url": "https://danispainting.net/service/commercial-painting/carpinteria",
    "telephone": "+1-805-403-8727",
    "email": "danispainting@gmail.com",
    "address": {
      "@type": "PostalAddress",
      "streetAddress": "133 E De La Guerra St, #267",
      "addressLocality": "Santa Barbara",
      "addressRegion": "CA",
      "postalCode": "93101",
      "addressCountry": "US"
    },
    "geo": [
      {
        "@type": "GeoCoordinates",
        "latitude": 34.3988,
        "longitude": -119.5185,
        "name": "Downtown Carpinteria - Linden Avenue"
      },
      {
        "@type": "GeoCoordinates",
        "latitude": 34.3985,
        "longitude": -119.5145,
        "name": "Carpinteria Plaza"
      },
      {
        "@type": "GeoCoordinates",
        "latitude": 34.3916,
        "longitude": -119.5377,
        "name": "Carpinteria Beach Hotels"
      }
    ],
    "areaServed": {
      "@type": "City",
      "name": "Carpinteria",
      "containedInPlace": {
        "@type": "AdministrativeArea",
        "name": "California"
      }
    },
    "serviceType": "Commercial Painting",
    "priceRange": "$$-$$$",
    "paymentAccepted": "Cash, Check, Credit Card, Financing Available",
    "openingHours": "Mo-Su 07:00-19:00",
    "image": "https://d2xsxph8kpxj0f.cloudfront.net/310519663313033271/eUvaV5v4nLRJmrJ6AKc5ww/hero-bg_5849f6b9_e05061fa.webp",
    "hasOfferCatalog": {
      "@type": "OfferCatalog",
      "name": "Carpinteria Commercial Painting Services",
      "itemListElement": [
        {
          "@type": "Offer",
          "itemOffered": {
            "@type": "Service",
            "name": "Linden Avenue Business Painting",
            "description": "Commercial painting for Linden Avenue restaurants, retail stores, and professional offices"
          }
        },
        {
          "@type": "Offer",
          "itemOffered": {
            "@type": "Service",
            "name": "Carpinteria Plaza Retail Painting",
            "description": "Shopping center and retail store painting for Carpinteria Plaza businesses"
          }
        },
        {
          "@type": "Offer",
          "itemOffered": {
            "@type": "Service",
            "name": "Beach Hotel Painting",
            "description": "Coastal hotel and vacation rental painting with salt-resistant, marine-grade coatings"
          }
        },
        {
          "@type": "Offer",
          "itemOffered": {
            "@type": "Service",
            "name": "Coastal Restaurant Painting",
            "description": "Restaurant painting with specialized coatings for coastal humidity and salt air"
          }
        }
      ]
    },
    "aggregateRating": {
      "@type": "AggregateRating",
      "ratingValue": "4.8",
      "reviewCount": "127"
    },
    "review": [
      {
        "@type": "Review",
        "author": {
          "@type": "Person",
          "name": "David R."
        },
        "reviewRating": {
          "@type": "Rating",
          "ratingValue": "5"
        },
        "reviewBody": "Danis Painting transformed our Linden Avenue restaurant. They worked nights to avoid disrupting our business and used specialized coatings that handle the coastal humidity."
      }
    ]
  };
}
